var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"techFeatList"},[_c('div',{staticClass:"techFeatCols el-size--small",domProps:{"innerHTML":_vm._s(_vm.replaceSuperscripts(_vm.componentData.content))}})])}
var staticRenderFns = []

export { render, staticRenderFns }